import React, { ReactNode } from 'react';
import { buttonStyles, ShowAllAdsLink, ShowAllAdsText } from './styled';
import { Button } from '../../../ui/Button';
import { ButtonType } from '../../../../styled/theme/types';

interface ShowAllProps {
  text?: string;
  href?: string;
  onClick: () => void;
}

interface ShowAllWrapperProps extends ShowAllProps {
  children: ReactNode;
  isButton?: boolean;
}

const ShowAllWrapper: React.FC<ShowAllWrapperProps> = ({
  href,
  onClick,
  children,
  isButton = false
}) => {
  if (!href) return <>{children}</>;

  return (
    <ShowAllAdsLink
      href={href}
      scroll={false}
      locale={false}
      shallow
      $isButton={isButton}
      onClick={e => {
        e.preventDefault();
        onClick();
      }}
    >
      {children}
    </ShowAllAdsLink>
  );
};

export const ShowAllTextButton: React.FC<ShowAllProps> = ({
  text,
  href,
  onClick
}) => (
  <ShowAllWrapper href={href} onClick={onClick}>
    <ShowAllAdsText
      onClick={!href ? onClick : undefined}
      tag="body_1"
      data-cy="show-all-results-button"
    >
      {text}
    </ShowAllAdsText>
  </ShowAllWrapper>
);

export const ShowAllButton: React.FC<ShowAllProps> = ({
  text,
  href,
  onClick
}) => (
  <ShowAllWrapper href={href} onClick={onClick} isButton>
    <Button
      cypress="show-all-results-button"
      text={text}
      onClick={!href ? onClick : undefined}
      state={ButtonType.edit}
      styles={buttonStyles}
    />
  </ShowAllWrapper>
);
